/**
 * Segmentation de texte pour le rendu avant/après tokenisé. Découpe un texte
 * en segments {text, highlighted} selon une liste de sous-chaînes à surligner
 * (valeurs PII originales pour le « avant », tokens pour le « après »).
 */

export interface Segment {
    text: string
    highlighted: boolean
}

function escapeRegExp(s: string): string {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function segment(text: string, needles: string[]): Segment[] {
    const valid = [...new Set(needles.filter((n) => n.length > 0))]
    if (valid.length === 0) {
        return [{ text, highlighted: false }]
    }
    const alternation = valid
        .sort((a, b) => b.length - a.length)
        .map(escapeRegExp)
        .join('|')
    const re = new RegExp(`(${alternation})`, 'g')

    const out: Segment[] = []
    let last = 0
    let match: RegExpExecArray | null
    while ((match = re.exec(text)) !== null) {
        if (match.index > last) {
            out.push({ text: text.slice(last, match.index), highlighted: false })
        }
        out.push({ text: match[0], highlighted: true })
        last = match.index + match[0].length
        if (match.index === re.lastIndex) {
            re.lastIndex++
        }
    }
    if (last < text.length) {
        out.push({ text: text.slice(last), highlighted: false })
    }
    return out
}
